export const SCREEN = {
  NOTEBOOK: '1280px',
  MOBILE: '769px',
}
